import React from 'react';
import { Spinner } from '@blueprintjs/core';
export default ({ className = '' }) =>
  (<div className={`text-center m-t-4 ${className}`}><Spinner /></div>);